<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="orderNo"
      :itemNames="['name_1','name_2','name_3']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="name_1" label="下单时间" v-bind="searchItemLayout">
        <a-range-picker
          @change="onOrderDateChange"
          :value="selectedOrderDate"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item slot="name_2" label="订单号(平台)" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="name_3" label="订单号(畅联)" v-bind="searchItemLayout">
        <a-input v-model="queryParams.dsnOrderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <template slot="orderStatus" slot-scope="rowItem">
        {{ rowItem.text|changLianOrderStateName }}
      </template>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm v-if="rowItem.record.dsnOrderState === 1 || rowItem.record.dsnOrderState === 2 "
                      title="是否要取消当前订单？" @confirm="cancelEvent(rowItem.record)">
          <a>取消订单</a>
        </a-popconfirm>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import ChangLianMixins from '@/views/service/serviceProvider/changLianConnection/mixins/ChangLianMixins'

export default {
  name: 'ChangLianOrderList',
  mixins: [ChangLianMixins],
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      selectedOrderDate: undefined
    }
  },
  methods: {
    //日期变更
    onOrderDateChange(dates, dateStrArr) {
      this.selectedOrderDate = dates
      this.queryParams.createStartTime = dateStrArr[0] || undefined //下单开始时间
      this.queryParams.createEndTime = dateStrArr[1] || undefined //下单结束时间
    },
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('/dsn/order/list', params)
    },
    getColumns() {
      return [
        {
          title: '订单编号（平台）',
          dataIndex: 'orderNo'
          // width: '150px',
        },
        {
          title: '订单编号（畅联）',
          dataIndex: 'dsnOrderNo'
          // width: "40%"
        },
        {
          title: '商品信息',
          dataIndex: 'orderGoodsName'
        },
        {
          title: '订单金额',
          dataIndex: 'orderTotalAmount'
        },
        {
          title: '下单时间',
          dataIndex: 'directCreateTime'
        },
        {
          title: '订单状态',
          dataIndex: 'dsnOrderState',
          scopedSlots: { customRender: 'orderStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 取消订单
    cancelEvent(record) {
      this.getHttpServices().getOrderService().post(`/dsn/order/refund/${record.orderNo}`).then(res => {
        this.$message.success('取消成功')
        this.$refs.pageList.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }

  }
}
</script>

<style scoped>

</style>
